<template>
  <PageHeader :showBreadcrumb="true" />
  <div class="container p-3 text-center">
    <h1 class="tx-col">Phase 3 - Reporting Phase</h1>
  </div>
</template>

<script>
export default {
  name: "ReportingPhase"
}
</script>

<style scoped>

</style>